import { SectionHeader } from '../SectionHeader';
import { Wrapper } from './SectionHeading.styles';
import type { SectionHeadingProps } from './SectionHeading.types';

export function SectionHeading({ title, children }: SectionHeadingProps) {
  return (
    <Wrapper>
      <SectionHeader title={title} />
      {children}
    </Wrapper>
  );
}
